// ── Friet Fighter — tuning & move data ──
// Alle getallen in "units" (wereld) en frames (60 Hz). Pas hier de feel aan,
// niet in de engine. Move-data is puur data → nieuwe moves/vechters = data, geen code.

import type { Move } from './types';

export const FPS = 60;

// ── Speelveld & vechter-afmetingen ──
export const STAGE_HALF = 7; // speelveld x ∈ [-7, 7]
export const FIGHTER_HALF_W = 0.45; // halve breedte pushbox/hurtbox
export const STAND_H = 1.8; // staande hurtbox-hoogte
export const CROUCH_H = 1.05; // gehurkte hurtbox-hoogte

// ── Beweging ──
export const WALK_SPEED = 0.06; // units/frame
export const JUMP_VY = 0.26; // begin-opwaartse snelheid
export const GRAVITY = 0.013; // units/frame²
export const FRICTION = 0.82; // demping op vx bij stun/idle

// ── Health & wedstrijd ──
export const MAX_HEALTH = 1000;
export const ROUND_TIME = 99 * FPS;
export const INTRO_TIME = 90; // "Ronde X — Vechten!"
export const ROUND_END_TIME = 150;
export const ROUNDS_TO_WIN = 2; // best-of-3
export const HITSTOP = 7; // freeze-frames bij raak/block

// ── Super-meter (M3) ──
export const MAX_METER = 100;
export const METER_HIT = 12; // aanvaller wint bij raak
export const METER_CHIP = 5; // aanvaller wint bij geblokte hit
export const METER_TAKE = 7; // verdediger wint (comeback) bij schade incasseren

// ── Moveset (Fase 0 — gedeeld door capsule-fighters) ──
export const MOVES: Record<string, Move> = {
  standLight: {
    id: 'standLight',
    name: 'Lichte Stoot',
    cancelable: true,
    startup: 4,
    active: 3,
    recovery: 8,
    damage: 30,
    chip: 4,
    hitstun: 16,
    blockstun: 12,
    pushHit: 0.1,
    pushBlock: 0.08,
    hbXMin: 0.4,
    hbXMax: 1.25,
    hbYMin: 1.05,
    hbYMax: 1.55,
  },
  standHeavy: {
    id: 'standHeavy',
    name: 'Zware Klap',
    cancelable: true,
    startup: 9,
    active: 4,
    recovery: 18,
    damage: 90,
    chip: 12,
    hitstun: 22,
    blockstun: 16,
    pushHit: 0.18,
    pushBlock: 0.12,
    hbXMin: 0.4,
    hbXMax: 1.7,
    hbYMin: 0.95,
    hbYMax: 1.6,
  },
  crouchLight: {
    id: 'crouchLight',
    name: 'Lage Por',
    cancelable: true,
    startup: 4,
    active: 3,
    recovery: 9,
    damage: 26,
    chip: 3,
    hitstun: 14,
    blockstun: 10,
    pushHit: 0.08,
    pushBlock: 0.06,
    hbXMin: 0.4,
    hbXMax: 1.3,
    hbYMin: 0.2,
    hbYMax: 0.75,
  },
  // Trap — eigen knop. Goede reik (benen), schade tussen licht en zwaar.
  kick: {
    id: 'kick',
    name: 'Frikandel Trap',
    cancelable: true,
    startup: 7,
    active: 4,
    recovery: 14,
    damage: 58, // balans: de trap is de lange-reik POKE (veilig), niet de schade-punish (dat is standHeavy 90)
    chip: 8,
    hitstun: 18,
    blockstun: 14,
    pushHit: 0.16,
    pushBlock: 0.1,
    hbXMin: 0.4,
    hbXMax: 1.85,
    hbYMin: 0.4,
    hbYMax: 1.15,
  },
  // Super — getriggerd met beide aanvalsknoppen tegelijk (lp+hp). Groot, traag, hoge schade.
  super: {
    id: 'super',
    name: 'Frikandel Razernij',
    startup: 8,
    active: 10,
    recovery: 24,
    damage: 180,
    chip: 30,
    hitstun: 30,
    blockstun: 20,
    pushHit: 0.26,
    pushBlock: 0.16,
    hbXMin: 0.4,
    hbXMax: 1.95,
    hbYMin: 0.6,
    hbYMax: 1.7,
  },
};
